import * as React from 'react';

import { ProductProviderDataService } from 'src/app/products/product-providers/product-provider.data';
import { ProductProviderEditorView } from './product-provider-editor.view';

interface Props {
	value: number | number[] | null;
	mode: ControlMode;
	onChange: (provider: ProductProviderItem) => void;
	setBusy(isBusy: boolean);
	label?: string;
	productType: number;
	required?: boolean;
	onGetErrorMessage?: () => Promise<ValidationError[]>;
}

export class ProductProviderEditorController extends React.Component<Props, {}> {
	static defaultProps = {
		multi: false
	};

	providerDataService: ProductProviderDataService;

	constructor(props: Readonly<Props>) {
		super(props);

		this.providerDataService = ProductProviderDataService.make();
	}

	render(): JSX.Element {
		return (
			<ProductProviderEditorView
				onGetErrorMessage={this.props.onGetErrorMessage}
				providerRequest={{ query: this.providerQuery, dataSet: this.providerDataService }}
				onChange={this.props.onChange}
				value={this.props.value}
				mode={this.props.mode}
				label={this.props.label}
				required={this.props.required}
			/>
		);
	}

	private providerQuery = async (q?: string): Promise<QueryResult<ProductProviderItem>> => {
		const { productType, setBusy } = this.props;

		try {
			setBusy(true);

			this.providerDataService.addFilter('isDeleted', 'eq', false);
			switch (productType) {
				case 0:
					this.providerDataService.addFilter('isActiveForGeneral', 'eq', true);
					break;
				case 1:
				case 5:
					this.providerDataService.addFilter('isActiveForAccommodation', 'eq', true);
					break;
				case 2:
					this.providerDataService.addFilter('isActiveForCarRent', 'eq', true);
					break;
				case 3:
					this.providerDataService.addFilter('isActiveForTransfer', 'eq', true);
					break;
				case 4:
					this.providerDataService.addFilter('isActiveForFlight', 'eq', true);
					break;
				case 9:
					this.providerDataService.addFilter('isActiveForTour', 'eq', true);
					break;
			}
			this.providerDataService.addSorting('id', 'asc', true);
			this.providerDataService.searchKeywords = q;

			const items = await this.providerDataService.load(query => query);
			return {
				items: items,
				totalCount: this.providerDataService.count
			};
		} finally {
			setBusy(false);
		}
	};
}



// WEBPACK FOOTER //
// ./src/app/products/product-providers/parts/product-provider-editor.controller.tsx